import { NAME as APP_NAME, ROUTES as APP_ROUTES } from 'constants';
import * as I18n from 'circe/I18n';

export const NAME = `${APP_NAME}/TRIPS`;

export const REDUCER_NAME = 'trips';

export const LISTING_ENDPOINT = `${OPERATIONS_EDGE}/api/itineraries/query`;

export const ROUTES = {
  ROOT: '/trips',
};

export const TRIP_STATUS = {
  PROPOSED: I18n.str('PROPOSED', 'Proposed'),
  SCHEDULED: I18n.str('SCHEDULED', 'Scheduled'),
  UN_SCHEDULED: I18n.str('UN_SCHEDULED', 'Unscheduled'),
  CONFIRMED: I18n.str('CONFIRMED', 'Confirmed'),
  REJECETED: I18n.str('REJECTED', 'Rejected'),
  IN_PROGRESS: I18n.str('IN_PROGRESS', 'In Progress'),
  BLOCKED: I18n.str('BLOCKED', 'Blocked'),
  CANCELLED: I18n.str('CANCELLED', 'Cancelled'),
  COMPLETED: I18n.str('COMPLETED', 'Completed'),
  REJECTED: I18n.str('REJECTED', 'Rejected'),
  PENDING_CLOSE: I18n.str('PENDING_CLOSE', 'Pendeing Close'),
};
